export default "__VITE_ASSET__y5NJLR6v__"